import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "contact-list" }
const _hoisted_2 = { class: "card-content" }
const _hoisted_3 = { class: "name" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Image = _resolveComponent("Image")
  const _component_Ellipsis = _resolveComponent("Ellipsis")
  const _component_RolesViewer = _resolveComponent("RolesViewer")
  const _component_Segment = _resolveComponent("Segment")
  const _component_CollapseGroup = _resolveComponent("CollapseGroup")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_CollapseGroup, {
      name: "list",
      items: $props.contacts,
      duration: 300
    }, {
      default: _withCtx(({item, index}) => [
        (_openBlock(), _createBlock(_component_Segment, {
          key: item.id,
          class: _normalizeClass(["contact-card pointer", {'with-roles': !!item.tracker_roles?.length}]),
          style: _normalizeStyle({marginTop: index > 0 ? '1.6rem' : 0}),
          onClick: $event => (_ctx.$emit('edit-person', item.id))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Image, {
              name: [item.first_name, item.last_name].join(' '),
              size: "4rem",
              src: item.avatar_url,
              shape: "circle"
            }, null, 8 /* PROPS */, ["name", "src"]),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, _toDisplayString(item.first_name) + " " + _toDisplayString(item.last_name), 1 /* TEXT */),
              _createVNode(_component_Ellipsis, {
                class: "position",
                text: item.position
              }, null, 8 /* PROPS */, ["text"]),
              (item.tracker_roles?.length)
                ? (_openBlock(), _createBlock(_component_RolesViewer, {
                    key: 0,
                    class: "roles",
                    roles: item.tracker_roles,
                    "visible-count": "3"
                  }, null, 8 /* PROPS */, ["roles"]))
                : _createCommentVNode("v-if", true)
            ])
          ]),
          _: 2 /* DYNAMIC */
        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["class", "style", "onClick"]))
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["items"])
  ]))
}